module.exports = __webpack_public_path__ + "6d4043d0ff944ef87c287ef36e5efcf1.svg";